export default __webpack_public_path__ + "static/media/tomato_salsa.d4aa87ab.wav";